module.exports = __webpack_public_path__ + "img/logo__blanco.f932e7b4.svg";